import Boundary from "./boundary";

class Universe extends Boundary {
    constructor() {
        super();
        this.min = new THREE.Vector3(-Infinity, -Infinity, -Infinity);
        this.max = new THREE.Vector3(Infinity, Infinity, Infinity);
        this.bBox = new THREE.Box3(this.min, this.max);
    }
}

export default Universe;
